import React, { useState, useEffect, createRef } from "react";
import FullCalendar, { formatDate } from "@fullcalendar/react";
// import { Calendar } from "@fullcalendar/core";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import resourceTimeGridPlugin from '@fullcalendar/resource-timegrid';
import scrollGridPlugin from '@fullcalendar/scrollgrid';
import styled from 'styled-components'
interface Props {
  initialView?: any;
}
const WorkCalendar: React.FC<Props> = ({
  initialView = 'dayGridMonth'
}) => {
  function renderEventContent(eventInfo: any) {
    console.log(eventInfo)
    return (
      <>
        <div className="div-event-day">
          <div className="bg-event-font mg-10">งานทั้งหมด</div>
          <div className="bg-event-title mg-10">{eventInfo.event.title}</div>
        </div>
      </>
    );
  }
  const ChangRender = styled.div``
  const calendarRef = createRef<FullCalendar>();

  const handleDateSelect = (selectInfo: any) => {
    let title = prompt('Please enter a new title for your event')
    let calendarApi = selectInfo.view.calendar
    console.log(selectInfo)
    calendarApi.unselect() // clear date selection

    // if (title) {
    //   calendarApi.addEvent({
    //     id: createEventId(),
    //     title,
    //     start: selectInfo.startStr,
    //     end: selectInfo.endStr,
    //     allDay: selectInfo.allDay
    //   })
    // }
  }
  return (
    <>
      <div style={{ padding: "20px 10px" }}>
        <ChangRender>
          <FullCalendar
           schedulerLicenseKey='<YOUR-LICENSE-KEY-GOES-HERE>'
            plugins={[
              interactionPlugin,
              scrollGridPlugin,
              resourceTimeGridPlugin,
              dayGridPlugin,
              timeGridPlugin,
            ]}
            editable={true}
            selectable={true}
            selectMirror={true}
            dayMaxEvents={true}
            select={handleDateSelect}
            eventContent={renderEventContent}
            initialEvents={[
              {
                title: "10",
                resourceId: 'a',
                start: "2022-11-02",
                display: "background",
                color: "#5baea9",
                textColor: "#FFF",
              },
              {
                title: "6",
                resourceId: 'a',
                start: "2022-11-22",
                display: "background",
                color: "#5baea9",
                textColor: "#FFF",
              },
            ]}
            ref={calendarRef}
            resources={[
              { id: 'a', title: 'Room A' },
              { id: 'b', title: 'Room B' }
            ]}
            headerToolbar={{
              left: '',
              center: '',
              right: ''
            }}
            initialView={initialView.value}
          />
        </ChangRender>
      </div>
    </>
  );
};
export default WorkCalendar;
